import Vue from 'vue'
import './styles/element-variables.scss'
import ElementUI from 'element-ui'
// 2.15.14 版本的样式文件路径无变化
// import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import i18n from './i18n'
import './styles/tailwind.css'
import * as utils from './utils/validate'
import store from "./store";
import Cookies from "js-cookie";
import {UPLOADING_IMAGE} from "./utils/config";


// 引入AOS动画库
import AOS from 'aos'
import 'aos/dist/aos.css'

// 引入并注册 GSAP 封装（页面内用 this.$createMotion() / this.$gsap）
import { installGsap, gsap } from '@/utils/gsap'
installGsap(Vue)
if (typeof window !== 'undefined') {
  window.gsap = gsap
}

// 初始化AOS
AOS.init({
  duration: 800,
  easing: 'ease-out-cubic',
  once: true,
  offset: 100,
  delay: 100,
  mirror: false
})


// 全局混合：断点依赖 store.windowWidth，随窗口变化响应式更新
// H5 <768 / 平板 768–1023 / PC ≥1024
Vue.mixin({
  computed: {
    $windowWidth() {
      const fromStore = this.$store && this.$store.state && this.$store.state.windowWidth
      if (typeof fromStore === 'number') return fromStore
      if (typeof window === 'undefined') return 1024
      return window.innerWidth
    },
    $isMobile() {
      return this.$windowWidth < 768
    },
    $isTablet() {
      return this.$windowWidth >= 768 && this.$windowWidth < 1024
    },
    $isDesktop() {
      return this.$windowWidth >= 1024
    },
    $breakpoint() {
      const width = this.$windowWidth
      if (width < 640) return 'xs'
      if (width < 768) return 'sm'
      if (width < 1024) return 'md'
      if (width < 1280) return 'lg'
      if (width < 1536) return 'xl'
      return '2xl'
    }
  },
  methods: {
    $scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    $scrollToElement(selector, offset = 80) {
      const element = document.querySelector(selector)
      if (element) {
        const elementPosition = element.getBoundingClientRect().top
        const offsetPosition = elementPosition + window.pageYOffset - offset

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        })
      }
    }
  }
})

// 全局组件
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import MinimalLayout from '@/layouts/MinimalLayout.vue'

Vue.component('DefaultLayout', DefaultLayout)
Vue.component('MinimalLayout', MinimalLayout)

// 全局指令
Vue.directive('animate', {
  inserted(el, binding) {
    const options = binding.value || {}
    const { animation, delay, duration } = options
    
    if (animation) {
      el.style.animation = `${animation} ${duration || '0.6s'} ease-out`
      if (delay) {
        el.style.animationDelay = delay
      }
    }
  }
})

Vue.directive('scroll-animation', {
  inserted(el) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate-fade-in-up')
          observer.unobserve(entry.target)
        }
      })
    }, {
      threshold: 0.1,
      rootMargin: '0px 0px -100px 0px'
    })
    
    observer.observe(el)
  }
})

// 全局过滤器
Vue.filter('formatDate', (value) => {
  if (!value) return ''
  const date = new Date(value)
  return date.toLocaleDateString('zh-CN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  })
})

Vue.filter('truncate', (value, length = 100) => {
  if (!value) return ''
  if (value.length <= length) return value
  return value.substring(0, length) + '...'
})

Vue.use(ElementUI)

// Element UI 2.x 单选原生 input 带 aria-hidden，聚焦时 Chrome 会报「Blocked aria-hidden…」；挂载后移除该属性即可消除警告且不影响样式。
function stripElRadioInputAriaHidden(root) {
  if (!root || !root.querySelectorAll) return
  root.querySelectorAll('.el-radio__original[aria-hidden="true"]').forEach((el) => {
    el.removeAttribute('aria-hidden')
  })
}

Vue.prototype.$validate = utils;
Vue.prototype.$store = store;
Vue.prototype.$cookies = Cookies;
Vue.prototype.$UPLOADING_IMAGE = UPLOADING_IMAGE;

const appVm = new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

appVm.$nextTick(() => {
  const root = document.getElementById('app')
  if (!root) return
  stripElRadioInputAriaHidden(root)
  let scheduled = false
  const scheduleStrip = () => {
    if (scheduled) return
    scheduled = true
    requestAnimationFrame(() => {
      scheduled = false
      stripElRadioInputAriaHidden(root)
    })
  }
  const mo = new MutationObserver(scheduleStrip)
  mo.observe(root, { childList: true, subtree: true })
})
